/**
 * Theme JS
 */

'use strict';


/*** Navbar ***/

var Navbar = (function () {

	// Variables
	// =========

	var $navbar = $('.navbar');
	var $navbarLink = $('.nav-link[href^="#"]'); // anchor link
	var $navbarCollapse = $('.navbar-collapse');
	var $window = $(window);

	// Methods
	// =======

	function makeNavbarDark() {
		$navbar.removeClass('navbar-light').addClass('navbar-dark');
	}
	function makeNavbarLight() {
		$navbar.removeClass('navbar-dark').addClass('navbar-light');
	}
	function toggleNavbarClass() {
		var scrollTop = $window.scrollTop();

		if (scrollTop > 5) {
			makeNavbarDark();
		} else {
			makeNavbarLight();
		}
	}

	// Events
	// ======

	// Toggle navbar class on document ready event
	toggleNavbarClass();

	// Window events
	$window.on({
		'scroll': function () {

			// Toggle navbar class on window scroll
			toggleNavbarClass();
		},
		'activate.bs.scrollspy': function () {

			// Navbar active link fix
			$navbarLink.filter('.active').focus();
		}
	});

	// Toggle navbar class on collapse
	$navbarCollapse.on({
		'show.bs.collapse': function () {
			makeNavbarDark();
		},
		'hidden.bs.collapse': function () {
			var scrollTop = $window.scrollTop();

			if (scrollTop == 0) {
				makeNavbarLight();
			}
		}
	});

	// Collapse navbar on an anchor link click
	$navbarLink.on('click', function () {
		$navbarCollapse.collapse('hide');
	});

})();


/*** Menu ***/

var Menu = function () {

	// Variables
	// =========

	var $menu = $('.section_menu__grid');
	var $menuNav = $('.section_menu__nav,p.menu_nav__item');
	var menuItem = '.section_menu__grid__item';

	// Methods
	// =======

	function _filter() {
		var g = (location.hash || $menuNav.find('li.active > a').data('filter')).substring(1);
		return $(this).data('item') == g;
	}

	function initMenu() {
		$menu.each(function () {
			var $this = $(this);
			var grid = $this.isotope({
				itemSelector: menuItem,
				filter: _filter
			});

			// Init Isotope when all images loaded
			grid.imagesLoaded().progress(function () {
				grid.isotope('layout');
			});

		});

		if (location.hash)
			toggleLinks(location.hash);
	};

	$(window).on('hashchange', function (e) {
		e.preventDefault();
	});

	function filterItems() {
		var targetMenu = $menu.filter('#tabs');

		targetMenu.isotope({
			filter: _filter
		});

		// Init Isotope when all images loaded
		targetMenu.imagesLoaded().progress(function () {
			targetMenu.isotope('layout');
		});
	};

	function toggleLinks(filter) {
		$menuNav.find('li').removeClass('active');
		$menuNav.find('*[data-filter="' + filter + '"]').parent().addClass('active');
	}

	// Events
	// ======

	// Init menu
	if ($menu.length) {
		initMenu();
	}

	let otherTabs = document.querySelectorAll('[data-tabto]');

	otherTabs.forEach((tab) => {
		tab.addEventListener('click', (e) => {
			e.preventDefault();
			goToTab(tab.dataset.tabto, true);
		});
	});

	// Filter menu items on click
	$menuNav.on('click', 'a', function (e) {
		e.preventDefault();

		goToTab($(this).data('filter'));

		if (['', '#gallery', '#about'].includes(location.hash))
			Gallery();
	});

	const goToTab = (name, scrollIntoView) => {
		location.hash = name;
		toggleLinks(name);
		filterItems();

		if (scrollIntoView)
			document.getElementById(name.substring(1))?.scrollIntoView({ behavior: 'smooth', block: 'end' });
	};

};

Menu();


/*** Gallery ***/

var Gallery = function () {

	// Variables
	// =========

	var $gallery = $('.section_gallery__grid');
	var galleryItem = '.section_gallery__grid__item';

	// Methods
	// =======

	function initGallery() {
		$gallery.each(function () {
			var $this = $(this);
			var grid = $this.isotope({
				itemSelector: galleryItem
			});

			// Init Isotope when all images loaded
			grid.imagesLoaded().progress(function () {
				grid.isotope('layout');
			});
		});
	};

	// Events
	// ======

	if ($gallery.length) {
		initGallery();
	}

};
Gallery();


/*** Google Map ***/

var GoogleMap = (function () {

	// Variables
	// =========

	var $map = $('.section_map__map');

	// Methods
	// =======

	function init() {

		$map.each(function () {
			var $this = $(this);

			// Get map data
			var mapLat = $this.data('lat');
			var mapLng = $this.data('lng');
			var mapZoom = $this.data('zoom');
			var mapInfo = $this.data('info');

			// Create a map object
			var map = new google.maps.Map($this[0], {
				center: {
					lat: mapLat,
					lng: mapLng
				},
				zoom: mapZoom,
				mapTypeControlOptions: {
					mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map']
				},
				disableDefaultUI: false,
				scrollwheel: false
			});

			// Create a marker
			var marker = new google.maps.Marker({
				position: {
					lat: mapLat,
					lng: mapLng
				},
				map: map,
				visible: true
			});
		});

	}

	// Events
	// ======

	if ($map.length) {
		init();
	}

})();


/*** Current Date ***/

var CurrentDate = (function () {

	// Variables
	// =========

	var $dateContainer = $('#js-current-year');

	// Methods
	// =======

	function appendDate() {
		var currentYear = new Date().getFullYear();

		$dateContainer.text(currentYear);
	}

	// Events
	// ======

	if ($dateContainer.length) {
		appendDate();
	}

})();


/*** Dishes ***/

var Dishes = (function () {

	// Variables
	// =========

	var $dishes = $('.section_dishes__carousel');

	// Methods
	// ========

	function init() {
		$dishes.each(function () {
			var $this = $(this);

			$this.flickity({
				cellAlign: 'left',
				setGallerySize: false,
				wrapAround: true,
				pageDots: false,
				imagesLoaded: true
			});
		});
	}

	// Events
	// =======

	if ($dishes.length) {
		init();
	}

})();


/*** Carousel ***/

var Carousel = (function () {

	// Variables
	// =========

	var $carousel = $('.section_carousel__slider');

	// Methods
	// =======

	function init() {
		$carousel.each(function () {
			var $this = $(this);

			$this.flickity({
				cellAlign: 'left',
				wrapAround: true,
				imagesLoaded: true
			});
		});
	}

	// Events
	// ======

	if ($carousel.length) {
		init();
	}

})();


/*** Testimonials ***/

var Testimonials = (function () {

	// Variables
	// =========

	var $testimonials = $('.section_testimonials__carousel');

	// Methods
	// =======

	function init() {
		$testimonials.each(function () {
			var $this = $(this);

			$this.flickity({
				cellAlign: 'left',
				wrapAround: true,
				imagesLoaded: true
			});
		});
	}

	// Events
	// ======

	if ($testimonials.length) {
		init();
	}

})();

var Search = (function () {
	var $searchBoxes = $('.autocomplete');

	function init() {
		$searchBoxes.each(function () {
			var $this = $(this);

			let autocomplete = new Autocomplete(('#' + $this.attr('id')), {
				search: (input) => {
					const url = "/search/suggest";

					return new Promise((resolve) => {
						if (input.length < 2) return resolve([]);

						fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ "query": input, "type": $this.data('type') }) })
							.then((response) => response.json())
							.then((data) => {
								let options = [];

								['completions', 'name'].forEach(d => {
									data[d].forEach((e) => {
										options = options.concat(e.options);
									});
								});

								resolve(options.filter(function (item, pos, self) {
									return self.some(val => { return val._id == item._id; })
								}));
							})
							.catch((error) => {
								resolve([]);
							});
					});
				},
				getResultValue: result => result._source.name || result.text,
				onSubmit: d => {
					if ($this.data('anchor')) {
						let slug = d._source.slug;
						location.hash = slug.substring(slug.indexOf('#'));
					}
				},
				renderResult: (result, props) => {
					if (result._source) {
						let html = `<li ${props}><div class="position-relative"><a class="stretched-link" href="${result._source.slug}">`;
						html += `${result._source.name || result.text}</a> <span class="text-muted float-right">${result._source.append || ""}</span>`;
						if (result._source.image)
							html += `<img src="${result._source.image}" style="height:120px" class="img-thumbnail img-responsive" />`;
						html += `</div></li>`;
						return html;
					} else {
						return `<li ${props}>${result.text}</li>`;
					}
				},
				debounceTime: 150,
				autoSelect: false
			});
		});
	}
	init();
})();